"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReportVariantType = exports.ReportManagementDataType = exports.ProductTabType = void 0;
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _section = _interopRequireDefault(require("@nucleo/section"));
var _constants = require("./constants");
function cov_2nneaj3lha() {
  var path = "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/type.js";
  var hash = "326fe93be9769f3cda7f73476d64e2c59cbabc79";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 30
        },
        end: {
          line: 11,
          column: 2
        }
      },
      "1": {
        start: {
          line: 13,
          column: 40
        },
        end: {
          line: 20,
          column: 2
        }
      },
      "2": {
        start: {
          line: 22,
          column: 33
        },
        end: {
          line: 29,
          column: 2
        }
      },
      "3": {
        start: {
          line: 31,
          column: 24
        },
        end: {
          line: 34,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "326fe93be9769f3cda7f73476d64e2c59cbabc79"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2nneaj3lha = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2nneaj3lha();
var ProductTabType = exports.ProductTabType = (cov_2nneaj3lha().s[0]++, _propTypes.default.shape({
  code: _propTypes.default.oneOf((0, _values.default)(_constants.ProductTabEnum)),
  sections: _propTypes.default.arrayOf(_section.default),
  arrFilters: _propTypes.default.array
}));
var ReportManagementDataType = exports.ReportManagementDataType = (cov_2nneaj3lha().s[1]++, _propTypes.default.shape({
  isReportContext: _propTypes.default.bool,
  reportGenerateUrl: _propTypes.default.string,
  reportVariants: _propTypes.default.arrayOf(_propTypes.default.object),
  seasonId: _propTypes.default.number,
  selectProductIds: _propTypes.default.arrayOf(_propTypes.default.number),
  onProductSelectChange: _propTypes.default.func
}));
var ReportVariantType = exports.ReportVariantType = (cov_2nneaj3lha().s[2]++, _propTypes.default.shape({
  reportId: _propTypes.default.number,
  reportName: _propTypes.default.string,
  rank: _propTypes.default.number,
  reportIdentifier: _propTypes.default.string,
  reportGroup: _propTypes.default.string,
  reportParameters: _propTypes.default.arrayOf(_propTypes.default.string)
}));
var ProductListType = (cov_2nneaj3lha().s[3]++, _propTypes.default.shape({
  /** Keep as array for sorting */
  tabs: _propTypes.default.arrayOf(ProductTabType)
}));
var _default = exports.default = ProductListType;